export const mockData = {
  heroSubtitle: "Uma introdução acessível aos conceitos de arquétipos, física quântica e consciência para quem está começando a explorar esses temas.",
  
  bonusTitle: "🎁 BÔNUS EXCLUSIVO",
  bonusText: "Ao comprar, você ganha GRÁTIS o livro completo \"O Homem e Seus Símbolos\" de Carl Jung (311 páginas)!",
  
  aboutBook: "Este material introdutório apresenta de forma didática conceitos básicos sobre arquétipos, física quântica e o papel da consciência na criação da realidade. Ideal para iniciantes que desejam ter um primeiro contato com esses temas fascinantes.",
  
  features: [
    {
      icon: 'sparkles',
      title: 'Introdução à Física Quântica',
      description: 'Conheça conceitos básicos sobre como a consciência do observador se relaciona com a realidade.'
    },
    {
      icon: 'brain',
      title: 'Conceitos de Arquétipos',
      description: 'Entenda o que são arquétipos e como eles podem influenciar nossa percepção da realidade.'
    },
    {
      icon: 'heart',
      title: 'Autoconhecimento',
      description: 'Reflexões iniciais sobre crenças pessoais e padrões de pensamento.'
    },
    {
      icon: 'star',
      title: 'Primeiros Passos',
      description: 'Um ponto de partida para quem quer começar a explorar esses conceitos.'
    }
  ],
  
  learningPoints: [
    "Conceitos básicos de física quântica aplicados à consciência",
    "Uma introdução ao conceito de arquétipos",
    "Reflexões sobre crenças limitantes e padrões mentais",
    "O conceito de 'Soltar' e desapego de resultados",
    "Ideias iniciais sobre prosperidade e mentalidade",
    "Introdução à relação entre Ego e consciência superior",
    "Primeiras reflexões sobre manifestação",
    "Conceitos básicos sobre propósito de vida"
  ],
  
  authorBio: "Kael'Thurion é um estudioso e entusiasta dos temas relacionados à física quântica, consciência e espiritualidade. Este material representa uma compilação introdutória de conceitos e reflexões para auxiliar iniciantes em sua jornada de autoconhecimento.",
  
  testimonials: [
    {
      name: "Maria Silva",
      text: "Uma ótima introdução aos temas de física quântica e consciência. Linguagem acessível e ideal para quem está começando. Vale muito a pena!"
    },
    {
      name: "João Santos",
      text: "Gostei da forma como o autor apresenta conceitos complexos de maneira simples. Bom material introdutório para entender esses temas."
    },
    {
      name: "Ana Costa",
      text: "Por R$ 10,00 é um excelente custo-benefício. Me deu uma boa base inicial sobre arquétipos e consciência. Recomendo para iniciantes!"
    }
  ]
};